import { generateTableSlice } from "./sliceTable";

const sliceInvoiceTable = generateTableSlice("invoice");

export const ActionsInvoiceTable = sliceInvoiceTable.actions;
export const ReducerInvoiceTable = sliceInvoiceTable.reducer;
export type TypeActionsInvoiceTable = typeof ActionsInvoiceTable;
